import { Stack, Typography, FormControl, Select, MenuItem, SelectChangeEvent, Grid } from "@mui/material";
import { useDuesSponsoredOrgContext } from '../../global/hooks/useDuesSponsoredOrgContext';
import { useIlpContext } from '../hooks/useIlpContext';
import { IOrganization } from "../../global/interfaces/IOrganization";

//This component is responsible for rendering the program name. 
export default function OrganizationSelector() {
    const { organizations, selectedOrganization, setSelectedOrganization } = useDuesSponsoredOrgContext();
    const { standAloneOrg, findAndSetSelectedRole, setAreChildrenLoading } = useIlpContext();
    let dropdownLabel: string = "Select a Program" ;

    let selectedOrgName: string | undefined = undefined;
    let selectedOrgKey: string | undefined = undefined;
    if (selectedOrganization !== undefined) {
        selectedOrgName = selectedOrganization.Name!;
        selectedOrgKey = selectedOrganization.OrganizationKey!;
        dropdownLabel = "Current Program";
    }

    const handleChange = (event: SelectChangeEvent) => {
        setAreChildrenLoading(true);
        let selectedOrg: IOrganization | undefined = undefined;
        let selectedKey: string | null | undefined = event.target.value.toLowerCase();
        if (selectedKey === null || selectedKey === undefined) return;

        if (standAloneOrg !== undefined && standAloneOrg.OrganizationKey?.toLowerCase() == event.target.value.toLowerCase()){
            selectedOrg = standAloneOrg;
        }
        else {
            selectedOrg = organizations?.find(x => x.OrganizationKey?.toLowerCase() == event.target.value.toLowerCase());
        }

        if (selectedOrg != null) {
            setSelectedOrganization(selectedOrg);
            findAndSetSelectedRole(selectedOrg);
        }
    };
      
    // Select dropdown listing all organizations. Selection will set role via IlpContext findAndSetSelectedRole();
    return (
                        <Grid item key='ilp-organization-selector' style={{ display: 'flex' }} xs={12} sm={6} md={6}>
                            <Stack>
                                <Typography variant="h5" color="black" component="div" sx={{ paddingLeft: 1 }}>{dropdownLabel}</Typography>
                                <FormControl size="small" sx={{ m: 1, width: 275 }}>
                                <Select
                                id="ilp-select-organizations"
                                value={selectedOrgKey}
                                name={selectedOrgName}
                                onChange={handleChange}
                                displayEmpty
                                >
                                {standAloneOrg && <MenuItem value={standAloneOrg.OrganizationKey!} key={`ilp-menu-item-${standAloneOrg.OrganizationKey}`}>{standAloneOrg.Name}</MenuItem>} 
                                {organizations?.sort((a, b) => (a.Name!.toLowerCase() < b.Name!.toLowerCase() ? -1 : 1)).map((item, index) => (<MenuItem value={item.OrganizationKey!} key={`ilp-menu-item-${item.OrganizationKey}-${index}`}>{item.Name}</MenuItem>))} 
                                </Select>
                                </FormControl>
                            </Stack>
                        </Grid>
    );
}